const ErrorLevel = {
  info: "note",
  danger: "error"
};
export default ErrorLevel;
